import React from 'react';
import PropTypes from 'prop-types';
import { Label, Checkbox } from 'rebass';

const FilterCheckbox = ({ label, checked, onChange, title }) => <Label title={title}><Checkbox checked={checked} onChange={onChange} /> {label}</Label>;
FilterCheckbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  title: PropTypes.string,
};
export default FilterCheckbox;



// WEBPACK FOOTER //
// ./src/components/molecules/FilterCheckbox/index.js